import { useLang } from '@/context/LanguageContext';

export const LanguageToggle = ({ testId = 'lang-toggle' }) => {
  const { lang, setLang } = useLang();
  const opt = (code, label) => (
    <button
      type="button"
      onClick={() => setLang(code)}
      data-testid={`${testId}-${code}`}
      aria-pressed={lang === code}
      className={`lang-pill-opt ${lang === code ? 'is-active' : ''} ${code === 'ar' ? 'font-arabic-ui' : ''}`}
    >
      {label}
    </button>
  );
  return (
    <div className="lang-pill" data-testid={testId} dir="ltr" role="group" aria-label="Language">
      {opt('en', 'EN')}
      {opt('ar', 'عربي')}
    </div>
  );
};
